import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';


@inject('Game3Store')
@observer
export default class Game3Step7 extends Component {

    _setWinners() {
        const playerOrdered = this.props.Game3Store.players.sort((a, b) => {
            return a.score < b.score;
        });

        let winners = [];
        let highScore = playerOrdered[0].score; // Gets the high score
        let losers = [];

        // Discover tie winners
        for (let w of playerOrdered) {

            if (w.score === highScore) {
                winners = [...winners, w];
            } else {
                losers = [...losers, w];
            }
        }

        this.props.Game3Store.loser = losers;
        this.props.Game3Store.winners = winners;
    }


    render() {
        this._setWinners();

        const winnerEl = this.props.Game3Store.winners.map(
            (w, index) => {
                return (
                    <div className="team-winner" key={index}>
                        <div className={"team-name " + w.team.color}>{w.name || "Team "}</div>
                        <div className="team-score">{w.score || 0} Points</div>
                    </div>
                )
            }
        );

        const loserEl = this.props.Game3Store.loser.map(
            (l, index) => {
                return (
                    <div className="team-loser" key={index}>
                        <div className={"team-name " + l.team.color}>{l.name || "Team "}</div>
                        <div className="team-score">{l.score || 0} Points</div>
                    </div>
                )
            }
        );


        this.props.Game3Store.resetGame();

        // const loser = this.props.Game3Store.loser;

        var styless = {width:"100%", margin: "40px"};

        return (
            <div className="step-5">
                {
                    loserEl.length > 0 ?
                        <div>
                            <div className="winner">
                                <h1>Winner{ this.props.Game3Store.winners.length > 1 && "s"}</h1>
                                <div className="teams-winners">
                                    {winnerEl}
                                </div>
                            </div>
                            <div className="loser">
                                <h1>Loser</h1>
                                <div className="teams-loser">
                                    {loserEl}
                                </div>
                            </div>
                        </div> :
                        <div>
                            <div className="winner">
                                <h1>Draw</h1>
                                <div className="teams-winners">
                                    <div style={styless} >
                                        {winnerEl}
                                    </div>
                                </div>
                            </div>
                        </div>

                }
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/containers/Game3/Game3Step7.js